import RequestTransferProductListPanel from "./requestTransferProductListPanel.container";
export default RequestTransferProductListPanel;
